/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type LicensingPaymentResultCode = "AMOUNTAUTHORISEDDOESNOTMATCHTOTALAMOUNT" | "BLOCKEDANIMAL" | "CUSTOMERSITEISDISABLED" | "DECLINED" | "ERROR" | "EXPIREDRABIESVACCINATION" | "LICENCEGENERATIONFAILED" | "LICENCETYPEDISCREPANCY" | "LICENCETYPENOTSUPPORTED" | "LIFETIMELICENCERENEWAL" | "PENDINGLICENSE" | "PETDISCREPANCY" | "REJECTEDLICENCE" | "SUCCEEDED" | "TOTALAMOUNTDISCREPANCY" | "VALIDATIONERROR" | "%future added value";
export type LicensingPaymentMethodInput = {
    paymentMethodRequest: LicensingPaymentMethodRequestInput;
    paymentRequest: LicensingPaymentRequestInput;
};
export type LicensingPaymentMethodRequestInput = {
    cardConnectPaymentRequest?: LicensingPaymentCardConnectRequestInput | null | undefined;
    convergePaymentRequest?: ConvergePaymentRequestInput | null | undefined;
    globalPaymentsPaymentRequest?: GlobalPaymentsPaymentRequestInput | null | undefined;
    monerisPaymentRequest?: LicensingPaymentMonerisRequestInput | null | undefined;
    payPalPayflowPaymentRequest?: LicensingPaymentPayPalPayflowRequestInput | null | undefined;
    payPalPaymentRequest?: LicensingPaymentPayPalRequestInput | null | undefined;
    stripePaymentRequest?: LicensingPaymentStripeRequestInput | null | undefined;
};
export type LicensingPaymentCardConnectRequestInput = {
    cardConnectToken?: string | null | undefined;
    cvc?: string | null | undefined;
    expiryDate: string;
    postcode?: string | null | undefined;
};
export type ConvergePaymentRequestInput = {
    token?: string | null | undefined;
};
export type GlobalPaymentsPaymentRequestInput = {
    amount: number;
    orderId: string;
    responseCode: string;
    responseMessage: string;
    timestamp?: string | null | undefined;
    transactionId: string;
};
export type LicensingPaymentMonerisRequestInput = {
    token: string;
};
export type LicensingPaymentPayPalPayflowRequestInput = {
    amount: number;
    originalTransactionId: string;
    result: number;
    resultMessage?: string | null | undefined;
    secureToken: string;
    secureTokenId: string;
    transactionTime?: string | null | undefined;
};
export type LicensingPaymentPayPalRequestInput = {
    orderId: string;
};
export type LicensingPaymentStripeRequestInput = {
    tokenId: string;
};
export type LicensingPaymentRequestInput = {
    acceptedTermsAndConditionsContractId?: number | null | undefined;
    animalIds: Array<string>;
    donationAmount: number;
    donationNotes?: string | null | undefined;
    totalAmount: number;
};
export type processPaymentMethodMutationVariables = {
    payment: LicensingPaymentMethodInput;
};
export type processPaymentMethodMutationResponse = {
    readonly licensingPaymentMethod: {
        readonly isSuccessful: boolean;
        readonly code: LicensingPaymentResultCode;
        readonly paymentId: string | null;
    } | null;
};
export type processPaymentMethodMutation = {
    readonly response: processPaymentMethodMutationResponse;
    readonly variables: processPaymentMethodMutationVariables;
};



/*
mutation processPaymentMethodMutation(
  $payment: LicensingPaymentMethodInput!
) {
  licensingPaymentMethod(payment: $payment) {
    isSuccessful
    code
    paymentId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "payment"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "payment",
                    "variableName": "payment"
                }
            ],
            "concreteType": "LicensingPaymentResult",
            "kind": "LinkedField",
            "name": "licensingPaymentMethod",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSuccessful",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paymentId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "processPaymentMethodMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "processPaymentMethodMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "ad7f677c6a409a03ecb49d295c42fa3c",
            "id": null,
            "metadata": {},
            "name": "processPaymentMethodMutation",
            "operationKind": "mutation",
            "text": "mutation processPaymentMethodMutation(\n  $payment: LicensingPaymentMethodInput!\n) {\n  licensingPaymentMethod(payment: $payment) {\n    isSuccessful\n    code\n    paymentId\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'df54507cdb7134f4c66e214444bda54b';
export default node;
